// extracted by mini-css-extract-plugin
module.exports = {"Container":"StatusCard_Container__sKAWu","Label":"StatusCard_Label__Jd6rW","Count":"StatusCard_Count__A_yUU","Icon":"StatusCard_Icon__FSd_S"};